import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import {
	TitleAndBreadcrumbsWrapper,
	ContentTypesHeaderContainer,
} from './contentTypesHeaderStyles.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BreadcrumbsSkeleton = styled.div({
	height: '12px',
	width: '74px',
	borderRadius: token('radius.full'),
	background: token('color.skeleton'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BreadcrumbsSeparatorSkeleton = styled.div({
	margin: `0px ${token('space.050')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:before': {
		flexShrink: 0,
		content: '"/"',
		color: token('color.background.accent.gray.subtlest'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div<{ isTitle?: boolean }>({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ isTitle }) => (isTitle ? '24px' : '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleSkeleton = styled.div({
	height: '14px',
	width: '326px',
	borderRadius: token('radius.full'),
	background: token('color.skeleton'),
});

type ContentTypesHeaderPlaceholderProps = {
	isFloating?: boolean;
};

const flexNavigationContainerPlaceholderStyles = xcss({
	alignItems: 'flex-start',
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	paddingLeft: 'space.150',
	paddingRight: 'space.150',
	boxSizing: 'border-box',
	justifyContent: 'space-between',
});

export const ContentTypesHeaderPlaceholder: FC<ContentTypesHeaderPlaceholderProps> = ({
	isFloating,
}) => {
	return (
		<ContentTypesHeaderContainer isFloating={isFloating}>
			<Box
				xcss={flexNavigationContainerPlaceholderStyles}
				testId="content-types-header-placeholder"
			>
				<TitleAndBreadcrumbsWrapper>
					<SkeletonWrapper>
						<BreadcrumbsSkeleton />
						<BreadcrumbsSeparatorSkeleton data-testid="content-types-header-placeholder-breadcrumbs-separator" />
						<BreadcrumbsSkeleton data-testid="content-types-header-placeholder-breadcrumbs-skeleton" />
					</SkeletonWrapper>
					<SkeletonWrapper isTitle>
						<TitleSkeleton />
					</SkeletonWrapper>
				</TitleAndBreadcrumbsWrapper>
			</Box>
		</ContentTypesHeaderContainer>
	);
};
